;(function () {
  'use strict'

  var Highcharts = require('highcharts')
  require('highcharts/modules/exporting')(Highcharts)
  require('highcharts/modules/drilldown')(Highcharts)

  angular.module('contrast.vendors').constant('Highcharts', Highcharts)
})()
